var map = {
	"./chalkboard.jpg": 5287,
	"./crosshair-menu.png": 6846,
	"./demo.gif": 4171,
	"./example-crosshairs/cod-standard.png": 3681,
	"./example-crosshairs/fortnite-shotgun.png": 3427,
	"./example-crosshairs/halo-circle.png": 9916,
	"./example-crosshairs/kovaaks-personal.png": 6656,
	"./example-crosshairs/overwatch-standard.png": 63,
	"./example-crosshairs/pubg-sniper.png": 2234,
	"./example-crosshairs/smg-zoom.png": 8877,
	"./kovaak-bg-concrete.jpg": 1381,
	"./kovaak-bg-dark.jpg": 9502,
	"./kovaak-bg-light.jpg": 4949,
	"./kovaaks_logo.svg": 592,
	"./readme-heading.png": 9708,
	"./weapons-menu.png": 9811
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;